import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { MapIcon, HomeIcon, PiggyBankIcon, FileTextIcon, RulerIcon, SearchIcon } from 'lucide-react';
export function Services() {
  const services = [{
    title: 'Individueller Sanierungsfahrplan (iSFP)',
    description: 'Analyse des Gebäudes und Entwicklung eines schrittweisen Sanierungskonzepts.',
    icon: MapIcon
  }, {
    title: 'Energieberatung Wohngebäude',
    description: 'Unabhängige Beratung für Eigentümer und Kaufinteressenten.',
    icon: HomeIcon
  }, {
    title: 'Fördermittelberatung',
    description: 'Unterstützung bei BAFA- und KfW-Förderungen.',
    icon: PiggyBankIcon
  }, {
    title: 'Energieausweise',
    description: 'Bedarfs- und Verbrauchsausweise für Wohngebäude.',
    icon: FileTextIcon
  }, {
    title: 'Fachplanung & Baubegleitung',
    description: 'Begleitung energetischer Sanierungsmaßnahmen.',
    icon: RulerIcon
  }, {
    title: 'Bestandsanalyse',
    description: 'Bewertung bestehender Gebäude und Entwicklung nachhaltiger Lösungen.',
    icon: SearchIcon
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section id="leistungen" className="py-24 md:py-32 bg-white" data-id="element-337">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-338">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-339">
          <h2 className="text-4xl md:text-5xl font-serif text-accent mb-6" data-id="element-340">
            Leistungen
          </h2>
          <p className="text-lg text-accent/70 font-light" data-id="element-341">
            Ganzheitliche Beratung und Planung für Ihr Bestandsgebäude – von der
            ersten Analyse bis zur Umsetzung.
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-342">
          {services.map((service, index) => <motion.div key={index} variants={itemVariants} className="group p-8 rounded-2xl bg-secondary/50 border border-accent/5 hover:bg-secondary hover:border-primary/30 transition-all duration-300" data-id="element-343">
              <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center mb-6 shadow-sm text-primary group-hover:scale-110 transition-transform duration-300" data-id="element-344">
                <service.icon size={24} strokeWidth={1.5} data-id="element-345" />
              </div>
              <h3 className="text-xl font-serif font-medium text-accent mb-3" data-id="element-346">
                {service.title}
              </h3>
              <p className="text-accent/70 font-light leading-relaxed" data-id="element-347">
                {service.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}